import React from "react";

import { formatNumber } from "../../../../../../utils/NumberHelpers";
import {
    adjustButtonMargin,
    ExpandedContent,
    isTotal,
    PriceLabel,
    PriceValue,
    ProductDetails,
    ProductRow,
    ProductRowLabel,
    ProductRowValue,
    ToggleMore,
} from "../../../../../shared/CalculatorProductDetails";
import List from "../../../../../shared/List";
import Button from "../../../../../shared/NewForms/Button";

const Product = ({
    product,
    onSubmit = null,
    consumption,
    expanded,
    onExpand,
}) => {
    // get priceGuarantee from product.remarks
    let remarkPriceGuarantee = null;
    let drawProduct = false;

    if (
        product !== undefined &&
        Object.keys(product).length !== 0 &&
        product.constructor === Object
    ) {
        remarkPriceGuarantee = product.remarks.find(
            (remark) => remark.bedingung === "Preisgarantie"
        );
        drawProduct = true;
    }

    if (drawProduct) {
        return (
            <ProductDetails>
                <ProductRow>
                    <ProductRowLabel>Bedarf:</ProductRowLabel>
                    <ProductRowValue>
                        {formatNumber(consumption)} kWh
                    </ProductRowValue>
                </ProductRow>
                <ProductRow>
                    <ProductRowLabel>Grundpreis:</ProductRowLabel>
                    <ProductRowValue>
                        {product ? product.grundpreisBrutto : ""} €/Jahr
                    </ProductRowValue>
                </ProductRow>
                <ProductRow>
                    <ProductRowLabel>Kilowattstunde:</ProductRowLabel>
                    <ProductRowValue>
                        {product ? product.arbeitspreisHTCtKWhBrutto : ""}{" "}
                        ct/kWh
                    </ProductRowValue>
                </ProductRow>
                <ProductRow>
                    <ProductRowLabel>Abschlag:</ProductRowLabel>
                    <ProductRowValue>
                        {product ? product.gesamtpreisBruttoProMonat : ""}{" "}
                        €/Monat
                    </ProductRowValue>
                </ProductRow>
                <ProductRow>
                    <ProductRowLabel>Erneuerbare Energien:</ProductRowLabel>
                    <ProductRowValue>
                        {Math.round(product.energyMix.erneuerbare)} %
                    </ProductRowValue>
                </ProductRow>
                <ProductRow>
                    <PriceLabel css={isTotal}>Gesamt:</PriceLabel>
                    <PriceValue css={isTotal}>
                        {product.gesamtpreisOhneBoniBrutto}&nbsp;&euro;
                    </PriceValue>
                </ProductRow>

                <Button
                    color="red"
                    css={adjustButtonMargin}
                    fullWidth
                    onClick={onSubmit}
                >
                    Bestellen
                </Button>

                <ToggleMore onClick={onExpand}>
                    {expanded ? "Weniger Details -" : "Mehr Details +"}
                </ToggleMore>

                {expanded && (
                    <ExpandedContent>
                        <List withContentWrapper>
                            <List.Item>
                                Kündigungsfrist:{" "}
                                <strong>{product.kuendigungsfrist}</strong>
                            </List.Item>
                            <List.Item>
                                Mindestvertragslaufzeit:{" "}
                                <strong>{product.vertragsverlaengerung}</strong>
                            </List.Item>
                            {remarkPriceGuarantee && (
                                <List.Item>
                                    Eingeschränkte Preisgarantie{" "}
                                    {remarkPriceGuarantee.Beschreibungstext}{" "}
                                    <strong>
                                        {
                                            remarkPriceGuarantee.preisgarantieBestandteile
                                        }
                                    </strong>
                                </List.Item>
                            )}
                            <List.Item>
                                Alle angezeigten Preise sind Bruttopreise und
                                beinhalten alle Steuern und Abgaben.
                            </List.Item>
                            <List.Item>
                                Stand:{" "}
                                {product.gueltigVon
                                    .split("-")
                                    .reverse()
                                    .join(".")}
                            </List.Item>
                        </List>
                    </ExpandedContent>
                )}
            </ProductDetails>
        );
    }

    return null;
};

export default Product;
